module.exports = __webpack_public_path__ + "ace-sans-demo.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ace-sans-demo.otf
// module id = 1575
// module chunks = 4